import { render, staticRenderFns } from "./cx.vue?vue&type=template&id=127c30a8&scoped=true"
import script from "./cx.vue?vue&type=script&lang=js"
export * from "./cx.vue?vue&type=script&lang=js"
import style0 from "./cx.vue?vue&type=style&index=0&id=127c30a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127c30a8",
  null
  
)

export default component.exports